<template>
    <!--搜索框-->
    <div class="serch">
        <div>
            <div class="pointer" @click="goRouter('/')">
                <div><img src="../assets/logo.jpg"></div>
            </div>
            <div>
               <div>
                    <input type="text" placeholder="请输入产品" name="" id="" v-model="keyWord" />
                </div>
                <div class="pointer" @click="serch">搜索</div>
            </div>
            <div class="pointer" v-if="$store.state.orgCode==$store.state.businessNo" @click="goPublish">发布需求</div>
            <div v-else style="opacity: 0;"></div>
            <div class="pointer" v-show="false">扫码关注</div>
        </div>
    </div>
</template>

<script>
    import bus from '../tools/bus.js'
    export default {
        name: "headerBar",
        data() {
            return {
                keyWord: '',
            }
        },
        methods: {
            serch() {
                let that = this;
                this.goRouter('/product');
                // bus.$emit('search', {
                //     keyWord: that.keyWord
                // })
            },
            goPublish() {
                if (!this.$store.state.userId) {
                    this.goRouter('/login');
                    return;
                } else {
                    this.goRouter('/publish');
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .serch {
        background: #FFFFFF;
        box-shadow: 0px 3px 7px 0px #D0DFFF;
        padding: 20px 0;
    }

    .serch>div {
        width: 1200px;
        margin: 0 auto;
    }

    .serch>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        height: 52px;
    }

    .serch>div:nth-child(1)>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
    }

    .serch>div:nth-child(1)>div:nth-child(1)>div:nth-child(1)>img {
        width: 200px;
        height: 56px;
    }

    .serch>div:nth-child(1)>div:nth-child(2) {
        display: flex;
        border: 1px solid #D50000;
        border-radius: 10px;
        width: 541px;
        height: 52px;
        box-sizing: border-box;
    }

    .serch>div:nth-child(1)>div:nth-child(2)>div:nth-child(1) {
        width: 450px;
        padding-left: 20px;
        box-sizing: border-box;
    }

    .serch>div:nth-child(1)>div:nth-child(2)>div:nth-child(1)>input {
        border: none;
        width: 100%;
        height: 100%;
        padding: 0;
    }

    .serch>div:nth-child(1)>div:nth-child(2)>div:nth-child(1)>input::-webkit-input-placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
    }

    .serch>div:nth-child(1)>div:nth-child(2)>div:nth-child(2) {
        width: 92px;
        background: #D50000;
        font-size: 16px;
        color: #F3F7FF;
        text-align: center;
        line-height: 50px;
        border-radius: 0 7px 7px 0;
        box-sizing: border-box;
    }

    .serch>div:nth-child(1)>div:nth-child(3) {
        width: 120px;
        height: 52px;
        background: #D50000;
        border-radius: 10px;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        color: #F3F7FF;
    }

    .serch>div:nth-child(1)>div:nth-child(4) {
        width: 135px;
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #D50000;
        border-radius: 10px;
        line-height: 50px;
        font-size: 16px;
        box-sizing: border-box;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue